export class StoreChainOtasErrors {
  static readonly type = '[OTAS] Store Chain Otas Errors';
  constructor(public chainOtasErrors: any) {}
}

export class CleanCurrentErrors {
  static readonly type = '[OTAS] Clean Current Errors';
}
